
import React from 'react';

export function useAttractionFormState() {
  // Attraction specific states
  const [entranceFee, setEntranceFee] = React.useState('');
  const [attractionType, setAttractionType] = React.useState('');
  const [suggestedDuration, setSuggestedDuration] = React.useState('');
  const [exhibits, setExhibits] = React.useState('');
  const [historicalSignificance, setHistoricalSignificance] = React.useState('');
  const [isIndoor, setIsIndoor] = React.useState(false);

  const resetAttractionFormState = () => {
    setEntranceFee('');
    setAttractionType('');
    setSuggestedDuration('');
    setExhibits('');
    setHistoricalSignificance('');
    setIsIndoor(false);
  };

  return {
    entranceFee, setEntranceFee,
    attractionType, setAttractionType,
    suggestedDuration, setSuggestedDuration,
    exhibits, setExhibits,
    historicalSignificance, setHistoricalSignificance,
    isIndoor, setIsIndoor,
    resetAttractionFormState
  };
}
